<template>
  <b-row>
    <b-col cols="12">
      <Card-Map-Count-Detail />
    </b-col>
    <b-col cols="12">
      <Card-Statistic-Count-Detail />
    </b-col>
    <b-col
      xl="6"
      lg="6"
      md="12"
      sm="12"
    >
      <Card-Pie-Chart-Count-Detail />
    </b-col>
    <b-col
      xl="6"
      lg="6"
      md="12"
      sm="12"
    >
      <CardCountingFormula />
    </b-col>
    <b-col
      xl="6"
      lg="6"
      md="12"
      sm="12"
    >
      <Card-Bar-Chart-Count-Detail />
    </b-col>
    <b-col>
      <CardCountingFormulaVKT />
    </b-col>
    <b-col cols="12">
      <Card-Line-Chart-Count-Detail />
    </b-col>
    <b-col cols="12">
      <Card-Cam-Count-Detail />
    </b-col>
    <b-col cols="12">
      <Card-Table-Count-Detail />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import CardTableCountDetail from '@/views/counting/detail/CardTableCountDetail.vue'
import CardMapCountDetail from '@/views/counting/detail/CardMapCountDetail.vue'
import CardStatisticCountDetail from '@/views/counting/detail/CardStatisticCountDetail.vue'
import CardCamCountDetail from '@/views/counting/detail/CardCamCountDetail.vue'
import CardPieChartCountDetail from '@/views/counting/detail/CardPieChartCountDetail.vue'
import CardBarChartCountDetail from '@/views/counting/detail/CardBarChartCountDetail.vue'
import CardLineChartCountDetail from '@/views/counting/detail/CardLineChartCountDetail.vue'
import CardCountingFormula from '@/views/counting/detail/CardCountingFormula.vue'
import CardCountingFormulaVKT from '@/views/counting/detail/CardCountingFormulaVKT.vue'

export default {
  components: {
    BRow,
    BCol,
    CardTableCountDetail,
    CardMapCountDetail,
    CardStatisticCountDetail,
    CardCamCountDetail,
    CardPieChartCountDetail,
    CardBarChartCountDetail,
    CardLineChartCountDetail,
    CardCountingFormula,
    CardCountingFormulaVKT,
  },
}
</script>

<style>

</style>
